var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tile"},[_c('div',{staticClass:"tile__content"},[_c('h3',{staticClass:"title-m"},[_vm._v("ADVERTISEMENT")])])])}]

export { render, staticRenderFns }